import type { ShipmentLSPStationCodeListResponse } from './api';

export const normalizeShipmentLSPStationCodeList = (
  list: ShipmentLSPStationCodeListResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((codeId) => ({
    label: codeId,
    value: codeId,
  }));
};
